<template>
  <s-task-list-layout
    :title="$t('PublicServant.Me.AL.DAFConfirmed')"
    :signbasket="isShowSignBasket"
    :back-u-r-l="`/tasklist/generalGroupList/${businessCode}/${currGroupId?currGroupId:''}`"
  >
    <template v-slot:toolbarExtension>
      <s-group-selector
        :business-code="businessCode"
        :curr-group-id.sync="currGroupId"
        :show-count="false"
      />
    </template>

    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <div v-show="!loading">
      <s-class-pdf-muti
        v-model="dialog"
        :file-ctxs="files"
      />
      <v-card
        v-for="(task,i) in taskList"
        :key="i"
        flat
        color="white"
        class="mb-4"
      >
        <v-card-text>
          <div>
            {{ $t('TaskList.ConfirmationTime') }} : {{ momentWithHyphen(task.completedTime).format('YYYY-MM-DD HH:mm') }}
          </div>
          <div class="float-right">
            <s-view-doc-btn
              v-if="!isApp && task.businessCode != BUSINESS_CODE.TRAINING && task.businessCode != BUSINESS_CODE.LEAVE_MARK"
              @previewFile="previewGeneralFileList(task)"
            />
            <!-- <s-class-pdf
              v-if="!isApp && task.businessCode != BUSINESS_CODE.TRAINING && task.businessCode != BUSINESS_CODE.LEAVE_MARK"
              :url="task.pdfInitParams"
            /> -->
          </div>
          <p class="text-h6 text--primary">
            {{ $chPtObjData('chinTaskListTitle', task.formAttribute) }}
          </p>
          <div>{{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}</div>
          <div>{{ $chPtObjData('chinTaskListDesc2', task.formAttribute) }}</div>

          <div
            v-if="task.formMessage && task.formMessage.message"
            class="pa-3 grey lighten-4"
          >
            {{ task.formMessage.message }}
          </div>
          <div
            v-if="task.workItemHistoryList && task.workItemHistoryList.length"
          >
            <br>
            <s-flow-detail-dialog :work-item-history="task.workItemHistoryList" />
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="px-2">
            {{ $t('TaskList.FinalAction') }}:
            <!-- <template v-if="task.status === 'H' && task.actionTypeId < 3"> -->
            <!-- <template v-if="task.status !== 'A' && task.actionTypeId < 3"> -->
            <template v-if="task.status !== 'A' && task.actionTypeId === 1">
              <span class="primary--text">{{ $t('TrainingClient.TaskList.Personal1.Agree') }}</span>
            </template>

            <template v-else-if="task.status !== 'A' && task.actionTypeId === 2">
              <span class="primary--text">{{ $t('eLeave.appStatus.A') }}</span>
            </template>

            <!-- <template v-if="task.status === 'H' && task.actionTypeId === 3"> -->
            <!-- <template v-else-if="task.status !== 'A' && (!task.actionTypeId || task.actionTypeId === 3)"> -->
            <template v-else-if="task.status !== 'A' && task.actionTypeId === 3">
              <span class="error--text">{{ $t('Text.Cancel') }}</span>
            </template>
            <!-- <template v-if="task.status === 'H' && task.actionTypeId === 4"> -->
            <template v-else-if="task.status !== 'A' && task.actionTypeId === 4">
              <span class="error--text">{{ $t('eLeave.appStatus.N') }}</span>
            </template>
            <template v-else-if="task.status === 'T'">
              <span class="primary--text">{{ $t('TaskList.TransferToOthers') }}</span>
            </template>
          </div>
          <!-- <v-btn
            icon
            @click="getPdfFromDms(task)"
          >
            <v-icon>
              mdi-file-document
            </v-icon>
          </v-btn> -->
        </v-card-actions>
      </v-card>

      <template v-if="taskList.length === 0">
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>
      <div>
        <v-pagination
          v-if="totalPage"
          v-model="page"
          :length="totalPage"
          circle
          @input="handlePageChange"
        />
      </div>
    </div>
    <p class="px-4 text-caption grey--text">
      *{{ $t('Workflow.OnlyShowXMonths', {'0': '3'}) }}
    </p>
  </s-task-list-layout>
</template>

<script>
import STaskListLayout from './components/STaskListLayout'
// import SClassPdf from '../../components/SClassPdf'
import SClassPdfMuti from '@/components/SClassPdfMuti'
import SViewDocBtn from './components/GeneralList/SViewDocBtn.vue'
import { workflow } from '../../store/modules/workflow/workflow'
import store from '../../store'
import { workflowModule } from '../../store/moduleName'
import { esignMethod } from '../../mixins/esignMethod'
import { taskMethod } from '../../mixins/taskMethod'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import SGroupSelector from './components/Layout/SGroupSelector'
import { BUSINESS_CODE } from '@/constant/constant'
import SFlowDetailDialog from './components/GeneralList/SFlowDetailDialog.vue'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    STaskListLayout,
    // SClassPdf,
    SClassPdfMuti,
    SViewDocBtn,
    SGroupSelector,
    SFlowDetailDialog
  },
  mixins: [taskMethod, esignMethod],
  props: {
    businessCode: {
      type: String,
      required: true
    },
    groupId: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      reassignedToEuid: '',
      isShowSignBasket: false,
      loading: false,
      itemsPerPage: 10,
      page: 1,
      totalPage: 0,
      currGroupId: null,
      taskList: [],
      filterText: '',
      BUSINESS_CODE,
      files: [],
      dialog: false // pdf dialog
    }
  },
  computed: {
    // ...mapWorkflowMultiRowFields({
    //   taskList: 'activeWorkItems'
    // }),
    // ...mapState(workflowModule, {
    //   workItem: state => state.item,
    //   taskList: state => state.historyWorkItems
    // })
  },
  watch: {
    currGroupId: function (val) {
      this.page = 1
      this.getGroupHistoryItems()
    }
  },
  created () {
    if (this.groupId) {
      this.currGroupId = parseInt(this.groupId)
    }
    // this.$store.dispatch(workflowModule + '/getItemByBusinessCode', this.businessCode)
    // this.$store.dispatch(workflowModule + '/getHistoryItems', this.businessCode)
  },
  methods: {
    momentWithHyphen: momentWithHyphen,
    handlePageChange (value) {
      this.page = value
      this.getGroupHistoryItems()
    }
  }
}
</script>
